import { IonContent, IonPage } from '@ionic/react';
import React from 'react';
import ComingSoonBanner from '../../../components/ui/ComingSoonBanner';

type Props = { title: string };

export default function ComingSoonPage(props: Props) {
  return (
    <IonPage>
      <IonContent>
        <div className="flex flex-col items-center justify-center w-full h-full p-6 max-sm:px-2">
          <div className="w-full min-h-[70%] sm:w-2/3">
            <ComingSoonBanner {...props} />
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
